import React, { useState } from 'react'
import { LinkButton } from '@which/seatbelt'
import { ChevronDownIcon, ChevronUpIcon } from '@which/seatbelt/src/components/Icons/Navigational'

import styles from './SeoContentBlock.module.scss'

interface Props {
  contentString: string
}

export const SeoContentBlock: React.FC<Props> = ({ contentString }) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)
  const htmlContent = contentString.replaceAll('<a', '<a data-which-id="seo-hyperlink"')

  return (
    <section className={styles.container}>
      <div
        className={isExpanded ? styles.seoContentWrapperExpanded : styles.seoContentWrapper}
        dangerouslySetInnerHTML={{
          __html: htmlContent,
        }}
        onFocus={() => setIsExpanded(true)}
      />
      <LinkButton
        aria-label={`${isExpanded ? 'hide' : 'show'}`}
        className={styles.button}
        data-which-id={`plp-content-block-${isExpanded ? 'collapse' : 'expand'}`}
        icon={isExpanded ? ChevronUpIcon : ChevronDownIcon}
        onClick={() => setIsExpanded(!isExpanded)}
        textStyle="sb-text-interface-body-small-regular"
      >
        {`Read ${isExpanded ? 'less' : 'more'}`}
      </LinkButton>
    </section>
  )
}
